// extracted by mini-css-extract-plugin
module.exports = {"like-button":"CoordiLikeButton_like-button__26okP","thumb":"CoordiLikeButton_thumb__3ABbF","active":"CoordiLikeButton_active__vQyqh"};